const EVERYTHING_BUT_MICRON = /([^µ]+)/g

export const toUpperCaseExceptMicron = (str: string): string => {
  return str ? str.replace(EVERYTHING_BUT_MICRON, (s) => s.toUpperCase()) : ''
}
